import React from "react";
import { useFiltersSkeletonStyles } from "./FiltersSkeleton.styles";
import { FiltersSkeletonProps } from "./types";

const FiltersSkeleton: React.FC<FiltersSkeletonProps> = ({
  sections = 3,
  itemsPerSection = 5,
}) => {
  const classes = useFiltersSkeletonStyles();

  return (
    <div className={classes.root}>
      {Array.from({ length: sections }).map((_, sectionIndex) => (
        <div className={classes.section} key={sectionIndex}>
          {/* Section title */}
          <div className={classes.title} />

          {/* Checkbox items */}
          {Array.from({ length: itemsPerSection }).map((__, itemIndex) => (
            <div className={classes.item} key={itemIndex}>
              <div className={classes.checkbox} />
              <div
                className={`${classes.label} ${
                  itemIndex % 2 === 0 ? classes.medium : classes.short
                }`}
              />
            </div>
          ))}

          {/* See more */}
          <div className={classes.seeMore} />
        </div>
      ))}
    </div>
  );
};

export default FiltersSkeleton;
